import { compose, withHandlers, withState } from 'recompose';
import { withActionByRole } from '../../../common/helpers/actions';
import * as actions from './actions';

export default compose(
  withState('isTaxesLoading', 'setIsTaxesLoading', false),
  withActionByRole(
    'fetchTaxes', actions.fetchShopTaxes, actions.fetchBarberTaxes, actions.fetchBrandTaxes,
  ),
  withHandlers({
    fetchTaxes: props => () => {
      props.setIsTaxesLoading(true);

      return props.fetchTaxes()
        .then(() => {
          props.setIsTaxesLoading(false);
        })
        .catch(() => {
          props.setIsTaxesLoading(false);
        });
    },
  })
);
